// import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
// import io from 'socket.io-client';
// import axiosInstance from '../utils/axios';

// const SocketContext = createContext();

// export const useSocket = () => {
//   const context = useContext(SocketContext);
//   if (!context) {
//     throw new Error('useSocket must be used within SocketProvider');
//   }
//   return context;
// };

// // 🔥 Anonymous ID helper (inline — taaki dependency na badhe)
// const STORAGE_KEY = 'rw_anonymous_id';
// const COOKIE_KEY = 'rw_anon';

// const generateAnonId = () => {
//   if (typeof crypto !== 'undefined' && crypto.randomUUID) {
//     return crypto.randomUUID().replace(/-/g, '');
//   }
//   return `anon${Date.now()}${Math.random().toString(36).slice(2, 10)}`;
// };

// // const getOrCreateAnonymousId = () => {
// //   if (typeof window === 'undefined') return null;
// //   let id = localStorage.getItem(STORAGE_KEY);
// //   if (!id) {
// //     const match = document.cookie.match(new RegExp(`${COOKIE_KEY}=([^;]+)`));
// //     if (match) id = match[1];
// //   }
// //   if (!id || id.length < 16) {
// //     id = generateAnonId();
// //     localStorage.setItem(STORAGE_KEY, id);
// //     document.cookie = `${COOKIE_KEY}=${id}; max-age=${60 * 60 * 24 * 365}; path=/; SameSite=Lax`;
// //   }
// //   return id;
// // };

// const getOrCreateAnonymousId = () => {
//   if (typeof window === "undefined") return null;

//   // 🔥 COOKIE PEHLE
//   let id = null;
//   const match = document.cookie.match(new RegExp(`${COOKIE_KEY}=([^;]+)`));
//   if (match) id = match[1];

//   if (id) {
//     const lsId = localStorage.getItem(STORAGE_KEY);
//     if (lsId !== id) {
//       localStorage.setItem(STORAGE_KEY, id);
//     }
//     return id;
//   }

//   // localStorage fallback
//   id = localStorage.getItem(STORAGE_KEY);

//   if (!id || id.length < 16) {
//     id =
//       typeof crypto !== "undefined" && crypto.randomUUID
//         ? crypto.randomUUID().replace(/-/g, "")
//         : `anon${Date.now()}${Math.random().toString(36).slice(2, 10)}`;

//     localStorage.setItem(STORAGE_KEY, id);
//     document.cookie = `${COOKIE_KEY}=${id}; max-age=${60 * 60 * 24 * 365}; path=/; SameSite=Lax`;
//   }

//   return id;
// };
// export const SocketProvider = ({ children }) => {
//   const [socket, setSocket] = useState(null);
//   const [isConnected, setIsConnected] = useState(false);
//   const [connectionError, setConnectionError] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const socketRef = useRef(null);

//   useEffect(() => {
//     let restaurantId = null;
//     let user = null;
//     let token = null;
//     let isPublicPage = false;
//     let anonymousId = null;

//     // 🔥 URL se restaurantId nikalo (public page)
//     const pathSegments = window.location.pathname.split('/');
//     const restaurantIndex = pathSegments.indexOf('restaurant');

//     if (restaurantIndex !== -1 && pathSegments[restaurantIndex + 1]) {
//       const urlRestaurantId = pathSegments[restaurantIndex + 1];
//       if (urlRestaurantId && urlRestaurantId.match(/^[0-9a-fA-F]{24}$/)) {
//         restaurantId = urlRestaurantId;
//         isPublicPage = true;
//       }
//     }

//     // 🔥 Public page pe anonymousId generate karo (IMPORTANT)
//     if (isPublicPage) {
//       anonymousId = getOrCreateAnonymousId();
//     }

//     if (!restaurantId) {
//       try {
//         const userStr = localStorage.getItem('restaurantApp_user');
//         if (userStr) {
//           user = JSON.parse(userStr);
//           restaurantId = user?._id || null;
//         }
//       } catch (e) {
//         console.error('Error parsing user:', e);
//       }
//     }

//     if (!isPublicPage) {
//       token = localStorage.getItem('restaurantApp_token');
//     }

//     if (!restaurantId) {
//       setIsLoading(false);
//       return;
//     }

//     const baseURL =
//       axiosInstance.defaults.baseURL ||
//       'https://demo.restaurantwala.in' ||
//       'https://restaurants-quick-qr.onrender.com';
//     const socketURL = baseURL.replace(/\/$/, '');

//     const socketOptions = {
//       withCredentials: true,
//       transports: ['websocket', 'polling'],
//       reconnection: true,
//       reconnectionAttempts: 5,
//       reconnectionDelay: 1000,
//     };

//     if (!isPublicPage && token) {
//       socketOptions.extraHeaders = {
//         Authorization: `Bearer ${token}`,
//       };
//     }

//     const socketInstance = io(socketURL, socketOptions);

//     socketRef.current = socketInstance;
//     setSocket(socketInstance);

//     socketInstance.on('connect', () => {
//       setIsConnected(true);
//       setConnectionError(null);
//       setIsLoading(false);

//       if (isPublicPage) {
//         // 🔥 Public menu viewer room
//         socketInstance.emit('public-join', { restaurantId });

//         // 🔥 Anonymous user room (order updates ke liye)
//         if (anonymousId) {
//           socketInstance.emit('anonymous-join', { anonymousId });
//           console.log('👤 Anonymous join emitted:', anonymousId);
//         }
//       } else {
//         socketInstance.emit('restaurant-join', {
//           restaurantId,
//           userId: user?._id || '',
//           role: user?.role || 'OWNER',
//           name: user?.ownerName || 'Owner',
//         });
//       }
//     });

//     socketInstance.on('disconnect', () => {
//       setIsConnected(false);
//     });

//     socketInstance.on('connect_error', (error) => {
//       setConnectionError(error.message);
//       setIsConnected(false);
//       setIsLoading(false);
//     });

//     socketInstance.on('join-confirm', () => {});
//     socketInstance.on('anonymous-join-confirm', (data) => {
//       console.log('✅ Anonymous join confirmed:', data);
//     });

//     const handleOnline = () => {
//       if (socketRef.current && !socketRef.current.connected) {
//         socketRef.current.connect();
//       }
//     };

//     window.addEventListener('online', handleOnline);

//     return () => {
//       window.removeEventListener('online', handleOnline);

//       if (socketRef.current) {
//         if (isPublicPage) {
//           socketRef.current.emit('public-leave', { restaurantId });
//         } else if (restaurantId) {
//           socketRef.current.emit('restaurant-leave', { restaurantId });
//         }
//         socketRef.current.disconnect();
//       }
//       setIsLoading(false);
//     };
//   }, []);

//   const reconnect = () => {
//     if (socketRef.current && !socketRef.current.connected) {
//       socketRef.current.connect();
//     }
//   };

//   return (
//     <SocketContext.Provider
//       value={{
//         socket,
//         isConnected,
//         connectionError,
//         reconnect,
//         socketId: socket?.id || null,
//         isLoading,
//       }}
//     >
//       {children}
//     </SocketContext.Provider>
//   );
// };


import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import io from 'socket.io-client';
import axiosInstance from '../utils/axios';

const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within SocketProvider');
  }
  return context;
};

// 🔥 Anonymous ID helper (inline — taaki dependency na badhe)
const STORAGE_KEY = 'rw_anonymous_id';
const COOKIE_KEY = 'rw_anon';

const getOrCreateAnonymousId = () => {
  if (typeof window === "undefined") return null;

  // 🔥 COOKIE PEHLE CHECK KARO
  let id = null;
  const match = document.cookie.match(new RegExp(`${COOKIE_KEY}=([^;]+)`));
  if (match) id = match[1];

  if (id) {
    const lsId = localStorage.getItem(STORAGE_KEY);
    if (lsId !== id) {
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  }

  // localStorage fallback
  id = localStorage.getItem(STORAGE_KEY);

  if (!id || id.length < 16) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID().replace(/-/g, "")
        : `anon${Date.now()}${Math.random().toString(36).slice(2, 10)}`;

    localStorage.setItem(STORAGE_KEY, id);
    document.cookie = `${COOKIE_KEY}=${id}; max-age=${60 * 60 * 24 * 365}; path=/; SameSite=Lax`;
  }

  return id;
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [connectionError, setConnectionError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const socketRef = useRef(null);

  useEffect(() => {
    let restaurantIdentifier = null;
    let user = null;
    let token = null;
    let isPublicPage = false;
    let anonymousId = null;

    // 🔥 URL se restaurantIdentifier nikalo (Slug ya ObjectId dono chalega)
    const pathSegments = window.location.pathname.split('/');
    const restaurantIndex = pathSegments.indexOf('restaurant');
    const menuIndex = pathSegments.indexOf('menu');

    if (restaurantIndex !== -1 && pathSegments[restaurantIndex + 1]) {
      restaurantIdentifier = pathSegments[restaurantIndex + 1];
      isPublicPage = true;
    } else if (menuIndex !== -1 && pathSegments[menuIndex + 1]) {
      restaurantIdentifier = pathSegments[menuIndex + 1];
      isPublicPage = true;
    }

    // 🔥 Public page pe anonymousId hamesha lo
    if (isPublicPage) {
      anonymousId = getOrCreateAnonymousId();
    }

    if (!restaurantIdentifier) {
      try {
        const userStr = localStorage.getItem('restaurantApp_user');
        if (userStr) {
          user = JSON.parse(userStr);
          restaurantIdentifier = user?._id || null;
        }
      } catch (e) {
        console.error('Error parsing user:', e);
      }
    }

    if (!isPublicPage) {
      token = localStorage.getItem('restaurantApp_token');
    }

    if (!restaurantIdentifier) {
      setIsLoading(false);
      return;
    }

    const baseURL =
      axiosInstance.defaults.baseURL ||
      'https://demo.restaurantwala.in' ||
      'https://restaurants-quick-qr.onrender.com';
    const socketURL = baseURL.replace(/\/$/, '');

    const socketOptions = {
      withCredentials: true,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    };

    if (!isPublicPage && token) {
      socketOptions.extraHeaders = {
        Authorization: `Bearer ${token}`,
      };
    }

    const socketInstance = io(socketURL, socketOptions);

    socketRef.current = socketInstance;
    setSocket(socketInstance);

    socketInstance.on('connect', () => {
      setIsConnected(true);
      setConnectionError(null);
      setIsLoading(false);

      if (isPublicPage) {
        // 🔥 Public room join (Slug ya ID dono se)
        socketInstance.emit('public-join', { restaurantId: restaurantIdentifier });

        // 🔥 Anonymous user room (Status updates ke liye sabse important)
        if (anonymousId) {
          socketInstance.emit('anonymous-join', { anonymousId });
          console.log('👤 Anonymous join emitted:', anonymousId);
        }
      } else {
        socketInstance.emit('restaurant-join', {
          restaurantId: restaurantIdentifier,
          userId: user?._id || '',
          role: user?.role || 'OWNER',
          name: user?.ownerName || 'Owner',
        });
      }
    });

    socketInstance.on('disconnect', () => {
      setIsConnected(false);
    });

    socketInstance.on('connect_error', (error) => {
      setConnectionError(error.message);
      setIsConnected(false);
      setIsLoading(false);
    });

    socketInstance.on('join-confirm', () => {});
    socketInstance.on('anonymous-join-confirm', (data) => {
      console.log('✅ Anonymous join confirmed:', data);
    });

    const handleOnline = () => {
      if (socketRef.current && !socketRef.current.connected) {
        socketRef.current.connect();
      }
    };

    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('online', handleOnline);

      if (socketRef.current) {
        if (isPublicPage) {
          socketRef.current.emit('public-leave', { restaurantId: restaurantIdentifier });
        } else if (restaurantIdentifier) {
          socketRef.current.emit('restaurant-leave', { restaurantId: restaurantIdentifier });
        }
        socketRef.current.disconnect();
      }
      setIsLoading(false);
    };
  }, []);

  const reconnect = () => {
    if (socketRef.current && !socketRef.current.connected) {
      socketRef.current.connect();
    }
  };

  return (
    <SocketContext.Provider
      value={{
        socket,
        isConnected,
        connectionError,
        reconnect,
        socketId: socket?.id || null,
        isLoading,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};